<router-outlet></router-outlet>
<math-notification-toast></math-notification-toast>
<math-app-update-toast />
